import {Component, Input} from '@angular/core';
import {BlobRendererViewerService} from './blob-renderer-viewer.service';

@Component({
    selector: 'vui-blob-renderer-viewer',
    templateUrl: './blob-renderer-viewer.component.html',
    styleUrls: ['./blob-renderer-viewer.component.scss']
})
export class BlobRendererViewerComponent {
    public dataUri: string;
    public loaded: boolean;
    public processing: boolean;
    private _screenshot: string;

    constructor(private rendererViewerService: BlobRendererViewerService) {
        this.loaded = false;
        this.processing = false;
    }

    public get screenshot(): string {
        return this._screenshot;
    }

    @Input()
    public set screenshot(screenshot: string) {
        if (screenshot) {
            this._screenshot = screenshot;
            this.dataUri = '';
            this.loaded = false;
            this.processing = true;
            this.rendererViewerService.get(this.screenshot).toPromise().then((blob) => {
                const fileReader: FileReader = new FileReader();
                fileReader.onloadend = () => {
                    this.dataUri = fileReader.result.toString();
                    this.loaded = true;
                    this.processing = false;
                };
                fileReader.readAsDataURL(blob);
            });
        }
    }
}
